


import { Table, TableColumnsType } from "antd";
import { BorrowerStatsTableTypes, dailyQuartileTableColumn } from "../../../../components/Dashboards/Tables/Columns";
import { formatRupee } from "../../../../utils";
interface DpdBucketProps {
  data: any[];
  // loading: boolean;
}

const QuartileBucket = ({ data }: DpdBucketProps) => {
    const QUARTILE_LABEL_MAP: Record<string, string> = {
  Q1: "Q1 (0–25%)",
  Q2: "Q2 (25%–50%)",
  Q3: "Q3 (50%–75%)",
  Q4: "Q4 (75%–100%)",
};

   const totals = data?.reduce(
  (acc, curr) => {
    acc.totalBorrowers += curr.totalBorrowers || 0;
    acc.agentCallMade += curr.agentCallMade || 0;
    acc.emailSent += curr.emailSent || 0;
    acc.smsSent += curr.smsSent || 0;
    acc.dunningNotices += curr.dunningNotices || 0;
    acc.legalNotices += curr.legalNotices || 0;
    acc.mediationNotices += curr.mediationNotices || 0;
    acc.recoveryAmount += curr.recoveryAmount || 0;
    acc.monthTillDate += curr.monthTillDate || 0;
    acc.totalOSAmount += curr.totalOSAmount || 0;
    return acc;
  },
  {
    totalBorrowers: 0,
    agentCallMade: 0,
    emailSent: 0,
    smsSent: 0,
    dunningNotices: 0,
    legalNotices: 0,
    mediationNotices: 0,
    recoveryAmount: 0,
    monthTillDate: 0,
    totalOSAmount: 0,
  }
);
  const dailybaseColumns: TableColumnsType<BorrowerStatsTableTypes> = [
      {
      title: "No. Of Borrowers",
      dataIndex: "totalBorrowers",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Agent Calls Made",
      dataIndex: "agentCallMade",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    // {
    //   title: "IVR Calls",
    //   dataIndex: "ivrCalls",
    //   render: (value) => <span>{value  ?? "-"}</span>,
    // },
    // {
    //   title: "No. Of Borrowers",
    //   dataIndex: "totalBorrowers",
    //   render: (value) => <span>{value  ?? "-"}</span>,
    // },
     {
    title: "Email Sent",
    dataIndex: "emailSent",
    render: (value: number) => <span>{value || "-"}</span>,
  },
    {
      title: "SMS Sent",
      dataIndex: "smsSent",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
        {
      title: "Dunning Notices",
      dataIndex: "dunningNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Legal Notices",
      dataIndex: "legalNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
    {
      title: "Mediation Notices",
      dataIndex: "mediationNotices",
      render: (value) => <span>{value  ?? "-"}</span>,
    },
     {
      title: "Recovered Amount",
      dataIndex: "recoveryAmount",
       render: (value) => <span>{formatRupee(value) ?? "-"}</span>,
    },
    {
      title: "MTD Collections (₹)",
      dataIndex: "monthTillDate",
       render: (value) => <span>{formatRupee(value) ?? "-"}</span>,
    },
    {
      title: "Outstanding Amount",
      dataIndex: "totalOSAmount",
      render: (value) =>
        <span>{Number.isFinite(value) ? formatRupee(value) : "-"}</span>,
    },
  ];

  const dailyQuartileTableColumn: TableColumnsType<BorrowerStatsTableTypes> = [
    {
    title: "Quartile",
    dataIndex: "bucket",
    key: "bucket",
    width:130,
    render: (value: string) => QUARTILE_LABEL_MAP[value] || value,
  },
    ...dailybaseColumns,
  ];

  return (
    <div className="mt-10">
      <Table
        // loading={isPhonebookPending || isPhonebookRefetching}
        columns={dailyQuartileTableColumn}
        dataSource={data || []}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
                      summary={() => (
    <Table.Summary.Row style={{ fontWeight: 600 }}>
      <Table.Summary.Cell index={0}>
        TOTAL
      </Table.Summary.Cell>

      <Table.Summary.Cell index={1}>
        {totals?.totalBorrowers}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={2}>
        {totals?.agentCallMade}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={3}>
        {totals?.emailSent}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={4}>
        {totals?.smsSent}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={5}>
        {totals?.dunningNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={6}>
        {totals?.legalNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={7}>
        {totals?.mediationNotices}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={8}>
        {formatRupee(totals?.recoveryAmount)}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={9}>
        {formatRupee(totals?.monthTillDate)}
      </Table.Summary.Cell>

      <Table.Summary.Cell index={10}>
        {formatRupee(totals?.totalOSAmount)}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  )}
      />
    </div>
  );
};

export default QuartileBucket;
;